/**
 * @generated SignedSource<<d68933bdffeb601da250038bb0fb2631>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PricingFrequency = "annually" | "monthly" | "weekly" | "%future added value";
export type PricingKind = "free" | "one_time" | "recurring" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useExperienceSettingsSelectedPlans_membershipPlansFragment$data = {
  readonly id: string;
  readonly membershipPlans: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly cover: string;
        readonly id: string;
        readonly isFreeMembership: boolean | null;
        readonly membershipBenefits: {
          readonly totalCount: number;
        } | null;
        readonly name: string;
        readonly pricing: {
          readonly amountCents: number;
          readonly frequency: PricingFrequency | null;
          readonly id: string;
          readonly kind: PricingKind;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"MembershipPlanExperiencePricingListItemFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "useExperienceSettingsSelectedPlans_membershipPlansFragment";
};
export type useExperienceSettingsSelectedPlans_membershipPlansFragment$key = {
  readonly " $data"?: useExperienceSettingsSelectedPlans_membershipPlansFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useExperienceSettingsSelectedPlans_membershipPlansFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useExperienceSettingsSelectedPlans_membershipPlansFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "membershipPlans",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "membership_plan"
        }
      ],
      "concreteType": "ProductNodeConnection",
      "kind": "LinkedField",
      "name": "products",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cover",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isFreeMembership",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MembershipBenefitNodeConnection",
                  "kind": "LinkedField",
                  "name": "membershipBenefits",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Pricing",
                  "kind": "LinkedField",
                  "name": "pricing",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "amountCents",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "frequency",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "kind",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "MembershipPlanExperiencePricingListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "products(type:\"membership_plan\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "503f29a54148c10dded5febe98251218";

export default node;
